import { SiteContextConfig } from '@spartacus/core';

export function getContextParameterValues(config: SiteContextConfig, parameter: string): string[] {
  return (config.context && config.context[parameter]) || [];
}

export function getContextParameterDefault(config: SiteContextConfig, parameter: string): string {
  const param = getContextParameterValues(config, parameter);
  return param && param.length ? param[0] : undefined;
}
